/* eslint-disable no-unused-vars */
const ALCHEMY_API_URL = process.env.NEXT_PUBLIC_ALCHEMY_API_URL || "";

import { AbiItem } from "web3-utils";
import CraftingMaster from "../../contracts/CraftingMaster.json";
import EconomyToolController from "../../contracts/EconomyToolController.json";

import {
	UseToastOptions,
} from "@chakra-ui/toast";

import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { EconomyTool } from "../../pages/alchemy";
const web3 = createAlchemyWeb3(ALCHEMY_API_URL);

// Professions Key:
// 1: Herbalism
// 2: Alchemy

const craftingMaster = new web3.eth.Contract(
	CraftingMaster.abi as AbiItem[],
	process.env.NEXT_PUBLIC_CRAFTING_MASTER
)

const economyToolController = new web3.eth.Contract(
	EconomyToolController.abi as AbiItem[],
	process.env.NEXT_PUBLIC_CRAFTING_MODIFIER_CONTROLLER
)

export const getAccount = async () => {
	if ((window as any).current_provider) {
		web3.setWriteProvider((window as any).current_provider)
		if ((window as any).current_provider.isMetaMask) {
			//metamask
			return (window as any).current_provider.selectedAddress
		} else {
			return (window as any).current_provider.accounts[0];
		}
	} 
};

export async function craftPotion(
	token: string,
	amount: number,
	raider: number,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	try {
		const account = await getAccount();
		const result = await craftingMaster.methods
			.craft(raider, token, amount)
			.send({ from: account, maxPriorityFeePerGas: null,
			maxFeePerGas: null }, function (err: any, res: any) {
				if (err) {
					toast({
						title: "Couldn't craft your potions...",
						description: err.message,
						status: "error",
						duration: 9000,
						position: "top",
						isClosable: true,
					});
					console.log(err);
				} else {
					console.log("Hash of the transaction: " + res);
				}
			});
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function craftPotionWithModifier(
	itemAddress: string,
	tool: EconomyTool,
	quantity: number,
	raider: number,
	toast: (options: UseToastOptions) => string | number | undefined
) {

	if (quantity == 1) {
		toast({
			title: "Use a raider instead",
			description: `Use a quantity of two or greater for a yield boost.`,
			status: "error",
			duration: 9000,
			position: "top",
			isClosable: true,
		});
		return false
	}

	if (tool.charges_left == 0) {
		toast({
			title: "No Weekly Charges Left",
			description: `This Economy Tool doesnt have any weekly charges yet.So you won't get any extra yield.`,
			status: "error",
			duration: 9000,
			position: "top",
			isClosable: true,
		});
		return false
	}

	console.log(`${raider} - ${itemAddress} ${quantity} ${tool.id}`)

	try {
		const account = await getAccount();
		const result = await craftingMaster.methods
			.craftWithModifier(raider, itemAddress, quantity, tool.id)
			.send({ from: account, maxPriorityFeePerGas: null,
			maxFeePerGas: null }, function (err: any, res: any) {
				if (err) {
					toast({
						title: "Couldn't craft your potions with modifier...",
						description: err.message,
						status: "error",
						duration: 9000,
						position: "top",
						isClosable: true,
					});
					console.log(err);
				} else {
					console.log("Hash of the transaction: " + res);
				}
			});
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function getRecipe(address: string) {
	return await craftingMaster.methods.getRecipe(address).call();
}

export async function getMinExperience(address: string) {
	return await craftingMaster.methods.itemToMinExperience(address).call();
}

export async function getRaiderExperienceEarned(address: string) {
	return await craftingMaster.methods.itemToRaiderExperienceEarned(address).call();
}

export async function itemToModifierExperienceEarned(address: string) {
	return await craftingMaster.methods.itemToModifierExperienceEarned(address).call()
}

export async function getEconomyTools() {
	const account = await getAccount()

	const response = await web3.alchemy.getNfts({owner: account, contractAddresses: [process.env.NEXT_PUBLIC_CRAFTING_MODIFIERS as string]})

	const newSet = []
	for await (const nft of response.ownedNfts) {
		const tokenId = Number(nft.id.tokenId);
		const lvlCall = economyToolController.methods.tokenToLevel(tokenId).call()
		const professionCall = economyToolController.methods.tokenToProfession(tokenId).call();
		const chargesLeftCall = craftingMaster.methods.chargesLeft(tokenId).call()
		const weeklyChargesCall = economyToolController.methods.tokenToWeeklyCharges(tokenId).call();
		const multiplierCall = economyToolController.methods.tokenToMultiplier(tokenId).call();
		const xpCall = economyToolController.methods.tokenToXp(tokenId).call();

		const res = await Promise.all([lvlCall, professionCall, chargesLeftCall, weeklyChargesCall, multiplierCall, xpCall])
		const level = Number(res[0])
		const professionId = Number(res[1])
		const chargesLeft = Number(res[2])
		const weekly_charges = Number(res[3])
		const multiplier = Number(res[4])
		const xp = Number(res[5])

		const newOne = {
			id: tokenId, 
			level: level,
			professionId: professionId,
			charges_left: chargesLeft,
			weekly_charges: weekly_charges,
			multiplier: multiplier,
			xp: xp
		}  as EconomyTool;
		console.log(newOne)
		newSet.push(newOne)
	}

	return newSet;
}
